/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UpdateBlockMutationVariables = {
    id: string;
    blockReason?: string | null | undefined;
};
export type UpdateBlockMutationResponse = {
    readonly updateBlock: {
        readonly result: string;
        readonly block: {
            readonly blockReason: string;
        };
    } | null;
};
export type UpdateBlockMutation = {
    readonly response: UpdateBlockMutationResponse;
    readonly variables: UpdateBlockMutationVariables;
};



/*
mutation UpdateBlockMutation(
  $id: ID!
  $blockReason: String
) {
  updateBlock(id: $id, blockReason: $blockReason) {
    result
    block {
      blockReason
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "blockReason"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "blockReason",
    "variableName": "blockReason"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "result",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "blockReason",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateBlockMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "UpdateBlock",
        "kind": "LinkedField",
        "name": "updateBlock",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ActiveBlock",
            "kind": "LinkedField",
            "name": "block",
            "plural": false,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "UpdateBlockMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "UpdateBlock",
        "kind": "LinkedField",
        "name": "updateBlock",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ActiveBlock",
            "kind": "LinkedField",
            "name": "block",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2c735a58c8d4bb2994f8fd8e1cfdca81",
    "id": null,
    "metadata": {},
    "name": "UpdateBlockMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateBlockMutation(\n  $id: ID!\n  $blockReason: String\n) {\n  updateBlock(id: $id, blockReason: $blockReason) {\n    result\n    block {\n      blockReason\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '0820414ba8ce343d3094488d3574bb22';
export default node;
